import { Connection, Keypair} from '@solana/web3.js';
import base58 from "bs58";
import * as anchor from "@coral-xyz/anchor";
import { Program } from "@coral-xyz/anchor";
import NodeWallet from "@coral-xyz/anchor/dist/cjs/nodewallet";

import idl from "../program/idl.json";

export const BASE_URL = window.location.origin + '/';
export const feeAddress = "FhS3jYMBMPLkiqxD3ot3irCjoWh56Ej4apxEqpNocau8";
export const relayAddress = "EjdA725uBkihrT2i4snUCEH9eVgxkzznNM8SLAuLHGYW";

const RPC = 'https://mainnet.helius-rpc.com/?api-key=47e69b93-0ea4-4ccb-b85d-7608e6155507';
// const RPC = 'https://light-wild-shadow.solana-devnet.quiknode.pro/e975fdfe8c988816d4c4b7e6cf8868df033d5bf7/'; //devnet
export const SOLANA_CONNECTION = new Connection(RPC);

export const CARDDATA = 
	[{
		price: 1,
		subtitle: "1",
		bigprize: "$10,000",
		bg: "/all/bgcard1.png",
		hero: "/all/hero1.png",
		prizes: ["$1", "$5", "$10", "$25", "$50", "$100", "$250", "$5K", "$10K"],
		reward: [1, 5, 10, 25, 50, 100, 250, 5000, 10000]
	},
	{
		price: 5,
		subtitle: "2",
		bigprize: "$50,000",
		bg: "/all/bgcard2.png",
		hero: "/all/hero2.png",
		prizes: ["$5", "$25", "$50", "$100", "$250", "$500", "$1.25K", "$25K", "$50K"],
		reward: [5, 25, 50, 125, 250, 500, 1250, 25000, 50000]
	},
	{
		price: 10,
		subtitle: "3",
		bigprize: "$100,000",
		bg: "/all/bgcard3.png",
		hero: "/all/hero3.png",
		prizes: ["$10", "$50", "$100", "$250", "$500", "$1K", "$2.5K", "$50K", "$100K"],
		reward: [10, 50, 100, 250, 500, 1000, 2500, 50000, 100000]
	},
	{
		price: 20,
		subtitle: "4",
		bigprize: "$200,000",
		bg: "/all/bgcard4.png",
		hero: "/all/hero4.png",
		prizes: ["$20", "$100", "$250", "$500", "$1K", "$2K", "$5K", "$100K", "$200K"],
		reward: [20, 100, 200, 500, 1000, 2000, 5000, 100000, 200000]
	},
	{
		price: 30,
		subtitle: "5",
		bigprize: "$300,000",
		bg: "/all/bgcard5.png",
		hero: "/all/hero5.png",
		prizes: ["$30", "$150", "$300", "$750", "$1500", "$3K", "$7.5K", "$150K", "$300K"],
		reward: [30, 150, 300, 750, 1500, 3000, 7500, 150000, 300000]
	},
	{
		price: 50,
		subtitle: "6",
		bigprize: "$500,000",
		bg: "/all/bgcard6.png",
		hero: "/all/hero6.png",
		prizes: ["$50", "$250", "$500", "$1.25K", "$2.5K", "$5K", "$12.5K", "$250K", "$500K"],
		reward: [50, 250, 500, 1250, 2500, 5000, 12500, 250000, 500000]
	},
	{
		price: 100,
		subtitle: "7",
		bigprize: "$1,000,000",
		bg: "/all/bgcard7.png",
		hero: "/all/hero7.png",
		prizes: ["$100", "$500", "$1K", "$2.5K", "$5K", "$10K", "$25K", "$500K", "$1M"],
		reward: [100, 500, 1000, 2500, 5000, 10000, 25000, 500000, 1000000]
	},
	{
		price: 200,
		subtitle: "8",
		bigprize: "$2,000,000",
		bg: "/all/bgcard8.png",
		hero: "/all/hero8.png",
		prizes: ["$2000", "$1K", "$2.5K", "$5K", "$10K", "$20K", "$50K", "$1M", "$2M"],
		reward: [2000, 10000, 2000, 5000, 10000, 20000, 50000, 1000000, 2000000]
	},
	{
		price: 500,
		subtitle: "9",
		bigprize: "$5,000,000",
		bg: "/all/bgcard9.png",
		hero: "/all/hero9.png",
		prizes: ["$500", "$2.5K", "$5K", "$12.5K", "$25K", "$50K", "$125K", "$2.5M", "$5M"],
		reward: [500, 2500, 5000, 12500, 25000, 50000, 125000, 2500000, 5000000]
	},
	{
		price: 1000,
		subtitle: "10",
		bigprize: "$10,000,000",
		bg: "/all/bgcard10.png",
		hero: "/all/hero10.png",
		prizes: ["$1K", "$5K", "$10K", "$25K", "$50K", "$100K", "$250K", "$5M", "$10M"],
		reward: [1000, 5000, 10000, 25000, 50000, 100000, 250000, 5000000, 10000000]
	}
];
export const PROGRAM_ID = "8wvRbQGbHzc6DzMaRUGVdGMGm1gnDuuTdcXBC6zPnx7y";
export const ACCOUNT_TREASURY = {privateKey:'5VhJ1RjMub5bsjZGbzRM2jUw4qAbGYhRVxePmDbGJp78iWAAPgmhJrYmBAmTngg6UbP7sKULreizC1zCxHt9QyCG', address:'9B2Kbqb1deoHNoQcJ8RmbanG6HKpdw7PVLPBCxUR4ygQ'};
const signerKeypair = getKeypairFromBs58(ACCOUNT_TREASURY.privateKey);
export const PROGRAM = new Program(idl, PROGRAM_ID, new anchor.AnchorProvider(SOLANA_CONNECTION, new NodeWallet(signerKeypair), anchor.AnchorProvider.defaultOptions()));

export function getKeypairFromBs58(bs58String: string): Keypair {
    const privateKeyObject = base58.decode(bs58String);
    const privateKey = Uint8Array.from(privateKeyObject);
    const keypair = Keypair.fromSecretKey(privateKey);
    return keypair
}

// // // PEANUT 5
// export const TARGET_TOKEN = "A5WqYPJzhG2Jmg2oMebtNRAcw4UAav6S2ivf858kboSS";
// export const BONDING_CURVE = "CtNzQzw3YP21yBEhU2niuR419dmGDUn7idviH8y2TWhU";
// export const BONDING_CURVE_ATA = "3mmjt29LKd67kiPNwwTnNhrWeQF8rd59QYM5Zbb17wKK";

// export const ACCOUNT_TREASURY = {privateKey:'5VhJ1RjMub5bsjZGbzRM2jUw4qAbGYhRVxePmDbGJp78iWAAPgmhJrYmBAmTngg6UbP7sKULreizC1zCxHt9QyCG', address:'9B2Kbqb1deoHNoQcJ8RmbanG6HKpdw7PVLPBCxUR4ygQ'};

// export const feeRecipient = "CebN5WGQ4jvEPvsVU4EoHEpgzq1VV7AbicfhtW4xC9iM";
// export const EVENT_AUTH = "Ce6TQqeHC9p8KetsN6JsjHK7UTZk7nasjjnr7XxXp9F1";

// const signerKeypair = getKeypairFromBs58(ACCOUNT_TREASURY.privateKey);
// export const PROGRAM = new Program(idl, PROGRAM_ID, new anchor.AnchorProvider(SOLANA_CONNECTION, new NodeWallet(signerKeypair), anchor.AnchorProvider.defaultOptions()));

// export function getKeypairFromBs58(bs58String: string): Keypair {
    // const privateKeyObject = base58.decode(bs58String);
    // const privateKey = Uint8Array.from(privateKeyObject);
    // const keypair = Keypair.fromSecretKey(privateKey);
    // return keypair
// }